import React from "react";

const Loading = () => {
  return (
    <div className="loadingContainer">
      <div id="loading-fg" className="loading-fg"></div>
      <div className="loading-bg"></div>
    </div>
  );
};

export default Loading;
